import React, { useState } from "react";
import Tag from "rsuite/Tag";
import TagGroup from "rsuite/TagGroup";
import Input from "rsuite/Input";
// import "rsuite/dist/styles/rsuite-default.css";
import 'rsuite/dist/rsuite.min.css';

export const DynamicTag = ({ data, setKeywords, placeholder }) => {
  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState(data || []);

  function handleButtonClick() {}

  function handleInputChange(inputValue) {
    setInputValue(inputValue);
  }

  function handleInputConfirm() {
    const trimmedValue = inputValue && inputValue.trim();
    let nextTags = trimmedValue ? [...tags, trimmedValue] : tags;
    setKeywords(nextTags);
    setTags(nextTags);
    setInputValue("");
  }

  function handleTagRemove(tag) {
    const nextTags = tags.filter((item) => item !== tag);
    setKeywords(nextTags);
    setTags(nextTags);
  }

  function renderInput() {
    return (
      <Input
        className="tag-input"
        size="xs"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputConfirm}
        onPressEnter={handleInputConfirm}
        onFocus={handleButtonClick}
        placeholder={placeholder || "Type here..."}
      />
    );
  }

  return (
    <TagGroup>
      {tags.map((item, index) => (
        <Tag
          key={index}
          closable
          onClose={() => {
            handleTagRemove(item);
          }}
        >
          {item}
        </Tag>
      ))}
      {renderInput()}
    </TagGroup>
  );
};
